import { nameOrKeyTitle } from "@eduviaos/shared";

/**
 * Applicant-facing title for an assessment template.
 *
 * Uses `template_name` (the name the centre typed). When that field is
 * missing or blank, falls back to a title made from `template_slug`.
 */
export function assessmentLabel(source: {
  template_name?: string | null;
  template_slug?: string | null;
}): string {
  return nameOrKeyTitle(source.template_name, source.template_slug, "Assessment");
}
